<div class="policyWidget beneWidget beneListWidget mmDirectWidget">
  <div class="wrap wrapClose">
    <div class="wrapClose__content header">
      <div class="header__content">
        <div class="header__logo-image wrapClose__logo" alt="MMDirect"></div>
        <button type="button" class="close" (click)="checkCancel();">Close</button>
      </div>
    </div>
  </div>

  <div class="wrap wrapHead">
    <div class="pageHead">
      <h1 *ngIf="policyAdminDown">Please contact {{channel.helpEmail}} for assistance.</h1>
      <h1 *ngIf="!policyAdminDown">Manage beneficiaries</h1>
      <div *ngIf="!policyAdminDown" class="subhead">
        Change your beneficiary designations and their information. You’ll want to make sure this is up to date and
        accurate to ensure claims against your policy are handled quickly.
      </div>
      <div *ngIf="!policyAdminDown" class="center">
        <img src="/common/widgets/icons/divider.svg" />
      </div>
    </div>
  </div>

  <div class="wrap wrapMain" *ngIf="!policyAdminDown">
    <form>
      <fieldset class="primary">
        <legend>Primary beneficiaries</legend>
        <div class="subtext">
          This is the loved one, estate or trust that would be first in line to receive your policy’s benefit.
        </div>
        <table class="beneList" *ngIf="primaryBeneList.length">
          <thead>
            <tr>
              <th scope="col">Beneficiary</th>
              <th scope="col">Allocation</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let bene of primaryBeneList">
              <td>{{getBeneName(bene)}}</td>
              <td>
                <input
                  type="text"
                  class="percent"
                  value="{{bene.ratio.toFixed(2)}}"
                  (focus)="setBene(undefined)"
                  (blur)="updatePercent(bene, $event, 'Primary')"
                />
                %
              </td>
              <td>
                <a *ngIf="canEditBene(bene)" (click)="editBene(bene, 'Primary');">Edit</a>
                <a (click)="deleteBeneficiary(bene, 'Primary')">Delete</a>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td>
                {{totalPercentPrimary.toFixed(2)}}% total allocation
                <div class="error" *ngIf="updatedPercent && totalPercentPrimary !== 100">
                  Total allocation must equal 100%
                </div>
              </td>
              <td></td>
            </tr>
          </tfoot>
        </table>
        <div class="add" *ngIf="primaryBeneList.length < 10">
          <a (click)="routeTo('pForm')">Add primary beneficiary</a>
        </div>
      </fieldset>

      <fieldset class="alternate">
        <legend>Alternate beneficiaries</legend>
        <div class="subtext">
          If there are no primary beneficiaries alive at the time of a claim, benefits will be paid to your
          alternate(s).
        </div>
        <table class="beneList" *ngIf="contingentBeneList.length">
          <thead>
            <tr>
              <th scope="col">Beneficiary</th>
              <th scope="col">Allocation</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let bene of contingentBeneList">
              <td>{{getBeneName(bene)}}</td>
              <td>
                <input
                  type="text"
                  class="percent"
                  value="{{bene.ratio.toFixed(2)}}"
                  (focus)="setBene(undefined)"
                  (blur)="updatePercent(bene, $event, 'Contingent')"
                />
                %
              </td>
              <td>
                <a *ngIf="canEditBene(bene)" (click)="editBene(bene, 'Contingent');">Edit</a>
                <a (click)="deleteBeneficiary(bene, 'Contingent')">Delete</a>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td>
                {{totalPercentContingent.toFixed(2)}}% total allocation
                <div class="error" *ngIf="updatedPercent && totalPercentContingent !== 100">
                  Total allocation must equal 100%
                </div>
              </td>
              <td></td>
            </tr>
          </tfoot>
        </table>
        <div class="add" *ngIf="contingentBeneList.length < 10 && !hideContingent">
          <a (click)="routeTo('cForm')">Add alternate beneficiary</a>
        </div>
        <div class="add fineprint" *ngIf="hideContingent">
          Since you selected the estate or trust of the insured, you do not need to designate alternate beneficiaries.
        </div>
      </fieldset>

      <fieldset class="custodian">
        <legend>Custodian</legend>
        <div class="subtext">
          If you have any beneficiaries that are minors, you may wish to designate a custodian to manage their benefits
          in the event of a claim.
        </div>
        <table class="beneList" *ngIf="custodianExists">
          <tbody>
            <tr>
              <td>
                {{custodian.firstName+" "+custodian.lastName}}
                <span class="custodianState" *ngIf="custodian.state">{{custodian.state}}</span>
              </td>
              <td>
                <a (click)="editCustodian()">Edit</a>
                <a (click)="deleteCustodian()">Delete</a>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="add" *ngIf="!custodianExists">
          <a (click)="routeTo('custodian')">Add custodian</a>
        </div>
      </fieldset>
    </form>
  </div>

  <div *ngIf="!policyAdminDown" class="wrap wrapFoot">
    <div class="cta">
      <button type="button" id="submitButton" (click)="saveBenes();" class="btnSubmit">Save changes</button>
      <button type="button" class="btnCancel" (click)="checkCancel();">Cancel</button>
    </div>
  </div>
</div>

<modal *ngIf="!policyAdminDown && modalService.showModal" [dismiss]="dismiss"></modal>
